'use client';

import classNames from 'classnames';
import { ReactNode, useEffect, useState } from 'react';
import styles from './HeaderWrapper.module.scss';

export const HeaderWrapper = ({ children }: { children: ReactNode }) => {
    const [isScrolled, setIsScrolled] = useState(false);
    const [zoom, setZoom] = useState<number>(
        typeof window !== 'undefined' ? (window.visualViewport?.scale ?? 1) : 1,
    );

    const handleScroll = () => {
        if (window.scrollY > 50) {
            setIsScrolled(true);
        } else {
            setIsScrolled(false);
        }
    };

    useEffect(() => {
        window.addEventListener('scroll', handleScroll);

        if (window.visualViewport) {
            const handleViewportChange = () => {
                setZoom(window.visualViewport?.scale ?? 1);
            };

            window.visualViewport.addEventListener('resize', handleViewportChange);

            return () => {
                window.removeEventListener('scroll', handleScroll);
                window.visualViewport?.removeEventListener('resize', handleViewportChange);
            };
        } else {
            return () => {
                window.removeEventListener('scroll', handleScroll);
            };
        }
    }, []);

    // Safari can misplace fixed elements during pinch zoom. PPWEB-997 deliberately
    // returns the header to normal document flow while the visual viewport is enlarged.
    const isViewportZoomed = zoom > 1;

    return (
        <header
            data-testid="header-wrapper"
            data-lp-header-position={isViewportZoomed ? 'flow' : 'fixed'}
            className={classNames(
                styles.wrapper,
                { fixed: !isViewportZoomed },
                { 'shadow-menuScroll': isScrolled },
            )}
        >
            {children}
        </header>
    );
};
